import { applyMiddleware, createStore, compose } from 'redux';
import createSagaMiddlware from 'redux-saga';
import rootReducer from './reducers/rootReducer';
import rootSaga from './sagas/rootSaga';
import analyticsMiddleware from './middleware/analyticsMiddleware';
import analyticsConfig from '../utils/analytics/analyticsConfig';

const composeEnhancers =
  (process.env.NODE_ENV === 'development' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const initiateStore = () => {
  const sagaMiddleware = createSagaMiddlware();
  const commentAnalyticsMiddleware = analyticsMiddleware(analyticsConfig);

  const middleware = [sagaMiddleware, commentAnalyticsMiddleware];
  const store = createStore(
    rootReducer,
    composeEnhancers(applyMiddleware(...middleware))
  );
  sagaMiddleware.run(rootSaga);
  return store;
};

export default initiateStore;
